import { render } from "./ArgonInputNew.vue?vue&type=template&id=10574865"
import script from "./ArgonInputNew.vue?vue&type=script&lang=js"
export * from "./ArgonInputNew.vue?vue&type=script&lang=js"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__